import React, { useMemo } from 'react';

const COLOR_MAP = {
    'bg-blue-500': '#3b82f6',
    'bg-purple-500': '#a855f7',
    'bg-cyan-500': '#06b6d4',
    'bg-orange-500': '#f97316',
    'bg-emerald-500': '#10b981',
    'bg-rose-500': '#f43f5e',
    'bg-amber-500': '#f59e0b',
    'bg-teal-500': '#14b8a6',
    'bg-pink-500': '#ec4899',
    'bg-violet-500': '#8b5cf6',
    'bg-[#1B3A6B]': '#1B3A6B'
};

/**
 * ProgressBar - Labeled horizontal progress bar with count and percentage.
 */
const ProgressBar = ({ label, count, total, color = '#8b5cf6', suffix = '' }) => {
    const percentage = useMemo(() => {
        const safeTotal = total || 1;
        return ((count / safeTotal) * 100);
    }, [count, total]);

    const displayPercentage = percentage.toFixed(1);

    const fillColor = COLOR_MAP[color] || (color.startsWith('#') ? color : '#8b5cf6');

    return (
        <div className="sd-progress-bar">
            <div className="sd-progress-bar__header">
                <span className="sd-progress-bar__label">{label}</span>
                <span className="sd-progress-bar__count">
                    {count.toLocaleString()}
                    {suffix} ({displayPercentage}%)
                </span>
            </div>
            <div className="sd-progress-bar__track">
                <div
                    className="sd-progress-bar__fill"
                    style={{ width: `${Math.min(percentage, 100)}%`, backgroundColor: fillColor }}
                />
            </div>
        </div>
    );
};

export default ProgressBar;
